module.exports = __webpack_public_path__ + "static/media/company-logo-nav.a6fef01d.png";